import React, {useCallback, useState} from 'react';
import Swal from 'sweetalert2';
import {useAuth} from '../../../../hooks/Auth';
import ExportFilesModal from '../../../Modals/ExportFilesModal';

const ExportFilesItem: React.FC = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const {user} = useAuth();

    const openModal = useCallback(() => {
        if (user.environment) {
            setModalVisible(true);
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text:
                    'É necessário cadastrar um ambiente antes de realizar esta ação.'
            });
        }
    }, [user]);

    return (
        <>
            <a
                className="dropdown-item cursor-pointer desktop"
                onClick={() => openModal()}
            >
                Exportar Arquivos
            </a>
            <a
                className="dropdown-item cursor-pointer mobile"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                onClick={() => openModal()}
            >
                Exportar Arquivos
            </a>

            {modalVisible && (
                <ExportFilesModal hide={() => setModalVisible(false)} />
            )}
        </>
    );
};

export default ExportFilesItem;
